import { render, staticRenderFns } from "./ShippingCompaines.vue?vue&type=template&id=c939533e&scoped=true"
import script from "./ShippingCompaines.vue?vue&type=script&lang=js"
export * from "./ShippingCompaines.vue?vue&type=script&lang=js"
import style0 from "./ShippingCompaines.vue?vue&type=style&index=0&id=c939533e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c939533e",
  null
  
)

export default component.exports